<mat-button-toggle-group class="shipment-category-toggle" [formControl]="categoryControl">
    <mat-button-toggle value="PARCEL" i18n>Small Parcel</mat-button-toggle>
    <mat-button-toggle value="LTL" i18n>LTL</mat-button-toggle>
</mat-button-toggle-group>